<template>
  <v-app
    style="
      background-color: unset !important;
      color: var(--v-allout-grey-base);
      line-height: unset;
      font-smooth: auto;
      -webkit-font-smoothing: auto;
      -moz-osx-font-smoothing: auto;
    "
  >
    <v-main>
      <action-form :action_id="action_id" :form-style="formStyle" />
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ActionForm from './shared-vue-components/ActionForm'

export default {
  name: 'ActionFormApp',
  components: {
    ActionForm
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    action_id: {
      type: String,
      required: true
    }
  },
  computed: {
    formStyle() {
      const style = {
        'margin-bottom': 0
      }
      if (this.isMemberFundraiser) {
        style['border-radius'] = '30px'
        style['box-shadow'] = 'none'
      }
      return style
    },
    ...mapGetters('actionForm', ['isMemberFundraiser'])
  }
}
</script>

<style lang="scss">
.v-application--wrap {
  min-height: unset !important;
  background-color: transparent;
}
</style>
